import React from 'react';

import { Typography } from '@mui/material';
import { Bookmark } from 'lucide-react';
import { SelectButton } from 'src/components';
import { bookmarkDialogOpenVar } from 'src/editor/toolbars/ToolbarMenus';
import { useEditingDisabled } from 'src/store/document/selectors';
import { makeStyles } from 'tss-react/mui';

import { useCloseOverflowMenu } from '../shared/ButtonsBarWithOverflowMenu';

const useStyles = makeStyles()(theme => ({
  buttonText: {
    marginLeft: theme.spacing(0.5),
  },
}));

export function BookmarkButton(): JSX.Element {
  const { classes } = useStyles();
  const disabled = useEditingDisabled();
  const closeOverflowMenu = useCloseOverflowMenu();

  return (
    <SelectButton
      disabled={disabled}
      onClick={() => {
        closeOverflowMenu();
        bookmarkDialogOpenVar(true);
      }}
    >
      <Bookmark size={24} strokeWidth={1.5} />
      <Typography className={classes.buttonText} color="inherit" variant="caption">
        Bookmark
      </Typography>
    </SelectButton>
  );
}
